@if (extensionPhone?.displayName) {
  <h5>Display Name</h5>
  <div class="extension-detail-item">{{ extensionPhone?.displayName }}</div>
}
<ng-container>
  <h5>Ring Timeout</h5>
  <div class="extension-detail-item">{{ extensionPhone?.ringTimeout }}</div>
</ng-container>
@if (timeZoneId) {
  <h5>Time Zone</h5>
  <div class="extension-detail-item">{{ timeZoneId }}</div>
}
<ndt-phone-number-detail-link
  [phoneNumber]="extensionPhone?.defaultPhoneNumber"
  [header]="'Default Phone Number'"
></ndt-phone-number-detail-link>
@if (extensionPhone?.forwardExternalNumber) {
  <h5>Forward To External Number</h5>
  <div class="extension-detail-item">{{ extensionPhone?.forwardExternalNumber | formatPhoneNumbers }}</div>
}
<ndt-extension-detail-link
  [extension]="extensionPhone?.forwardExtension"
  [header]="'Forward To Extension'"
></ndt-extension-detail-link>
<ndt-extension-detail-link
  [extension]="extensionPhone?.routeBusyExtension"
  [header]="'Route Busy Extension'"
></ndt-extension-detail-link>
<ndt-extension-detail-link
  [extension]="extensionPhone?.routeNoAnswerExtension"
  [header]="'Route No Answer Extension'"
></ndt-extension-detail-link>
<ng-container>
  <h5>DND Status</h5>
  <div class="extension-detail-item dnd-status-item">
    <span class="dnd-status-text">{{ dndStatus ? dndStatus : 'Available' }}</span>
    <a class="change-dnd-status-link" (click)="onDNDStatusChangeClick()">(Change)</a>
  </div>
</ng-container>
@if (isSystemUser) {
  <h5>Phone Domain</h5>
  <div class="extension-detail-item domain-text">{{ domain }}</div>
}
